export default "__VITE_ASSET__cf80c388__"